import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import {
  WEB_COMPONENT_GRID_VIEW,
  WEB_COMPONENT_MAINTENANCE_WINDOW_FORM,
  WEB_COMPONENT_MAINTENANCE_WINDOW_GRID,
  WEB_COMPONENT_MAINTENANCE_WINDOWS_SIDE_NAV,
} from '../../../webcomponents.constants';
import { translateFn } from '../../../utils/translator.helper';

export class MaintenanceWindowsAppView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$maintenanceWindowsGrid = this.shadow.querySelector(WEB_COMPONENT_MAINTENANCE_WINDOW_GRID);
    this.dom.$maintenanceWindowForm = this.shadow.querySelector(WEB_COMPONENT_MAINTENANCE_WINDOW_FORM);
    this.dom.$maintenanceWindowSideNav = this.shadow.querySelector(WEB_COMPONENT_MAINTENANCE_WINDOWS_SIDE_NAV);
    this.dom.$title = this.shadow.querySelector('.title');
    this.dom.$filtersTitle = this.shadow.getElementById('filtersTitle');
    this.dom.$filtersTitle.innerHTML = this.dependencies.translateFn('Maintenance windows').toUpperCase();

    // side nav texts translated
    this.dom.$maintenanceWindowSideNav.label = this.dependencies.translateFn('PATCH MANAGEMENT');
    this.dom.$maintenanceWindowSideNav.allPatches = this.dependencies.translateFn('All patches ');
    this.dom.$maintenanceWindowSideNav.securityPatches = this.dependencies.translateFn('Security patches');
    this.dom.$maintenanceWindowSideNav.nonSecurityPatches = this.dependencies.translateFn('Non-security patches');
    this.dom.$maintenanceWindowSideNav.manuallyApprovedPatches = translateFn('Manually approved patches');

    this.getTranslations();
    this.setTranslatedStrings();
    this.injectDependenciesInChildren();
  }

  buildView(data: any) {
    this.dom.$maintenanceWindowForm.isVisible = false;
  }

  buildSuccessView(data: any) {
    // do nothing
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getMaintenanceWindowsStrings();
  }

  private injectDependenciesInChildren() {
    if (this.dom.$maintenanceWindowsGrid.injectDependencies) {
      this.dom.$maintenanceWindowsGrid.injectDependencies(this.dependencies);
      this.dom.$maintenanceWindowsGrid.start().catch(console.error);
    }
  }

  showMaintenanceWindowForm() {
    this.dom.$maintenanceWindowForm.controller?.view.setLoadingState();
    this.dom.$maintenanceWindowForm.isVisible = true;
  }
}
